import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Title } from "@vds/typography";

import { Table, TableBody, TableRow, Cell, TableHeader } from "@vds/tables";
import { Loader } from "@vds/loaders";
import { Tooltip } from "@vds/tooltips";

import moment from "moment";
import { connect } from "react-redux";
import * as Actions from "../../store/actions/cases/allCasesActions";
import * as ViewCasesDetailsActions from "../../store/actions/cases/viewCaseDetailsActions";
import styled from "styled-components";
import DateFilter from "./DateFilter";
import DropdownFilter from "./DropdownFilter";
import PageAlignment from "./PageAlignment";
import CreateNewCase from "./CreateNewCase";
import * as CreateCaseActions from "../../store/actions/cases/createCaseActions";
import AddAttachmentTryAgain from "./AddAttachmentTryAgain";
import * as GlobalActions from "../../store/actions/global/global";
import FailedToLoadData from "../../pages/Login/failedToLoadData";
import { useTranslation } from "react-i18next";
import { changeLanguageHandler } from "../../util/userLanguageUtils";
import { SortIconStyle1, SortIconStyle, CustomisedTertiaryButton, CaseNumberTextLink, CPButton } from "../../constants/common/StyledGlobalConstants";
import { helpNavigationHandler } from "../../util/helpURLNavigation";
import { handleDateTimeZone } from "../../util/dateUtils";
import SearchFilterRedesign from "./RedesignedComponents/SearchFilterRedesign";
import CPNotification from "../../pages/Login/CPNotification";
import AscendingSortIcon from "../../assets/icons/sort-ascending.png";
import DescendingSortIcon from "../../assets/icons/sort-descending.png";
import NoSort from "../../assets/icons/no-sort.png";
import Chip from "./Chip";
import "../../components/common/RouterPrompt.css";
import RedesignedModal from "../common/RedesignedModal";
import EmptylistNotification from "../billingPayment/EmptylistNotification";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import { chatDisplayHandler } from "../../util/chatBotUtils";
import PropTypes from "prop-types";

const { TABLET, DESKTOP, LARGE_DESKTOP } = DEVICE_BREAKPOINTS;

export const CustomisedTitle = styled.div`
  & h1 {
    font-family: "neue-haas-grotesk-display";
    font-style: normal;
    font-weight: 700;
    font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
    line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
    word-break: break-word;
  }
  &:focus {
    outline: none;
  }
`;

export const Wrapper = styled.div`
  display: ${(props) => (props.display ? props.display : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "")};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  padding-top: ${(props) => (props.paddingTop ? props.paddingTop : "")};
  justify-content: ${(props) => (props.justifyContent ? props.justifyContent : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : "")};
  flex-wrap: ${(props) => (props.flexWrap ? props.flexWrap : "")};
  width: ${(props) => (props.width ? props.width : "")};
  align-items: ${(props) => (props.alignItems ? props.alignItems : "")};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "")};
`;

export const CustomisedTextLink = styled.a`
  font-family: "neue-haas-grotesk-text";
  cursor: pointer;
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  width: ${(props) => (props.width ? props.width : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  color: #0077b4;
  border-bottom: 1px solid #0077b4;
  &:hover {
    border-bottom: 2px solid #0077b4;
  }
  &:active {
    color: #0077b4;
    border-bottom: 1px solid #0077b4;
  }
  &:focus {
    border-radius: 2px;
    outline: 2px solid #0077b4 !important;
  }
  ::after {
    border: none !important;
  }
`;

const TextWrapper = styled.p`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
`;

const CaseListTable = styled(Table)`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 18px !important;
  @media (max-width: 1023px) {
    margin-top: 0rem;
  }
  margin-top: 0;
  margin-bottom: 0rem;
  & thead {
    border-bottom: ${(props) => (props.borderBottom ? props.borderBottom : "2px solid #000000")};
    border-top: ${(props) => (props.borderTop ? props.borderTop : "")};
  }
  & tbody {
    & tr {
      & td {
        padding-top: 0.8rem;
        padding-bottom: 0.701rem;
        // padding: 0.8rem 0 0.701rem 1.5rem;
        @media (max-width: 1000px) {
          padding: 1rem 0 0.75rem 0.5rem;
        }
        @media (max-width: 1023px) {
          font-size: 0.75rem;
        }
      }
    }
    & tr:last-child {
      border-bottom: 1px solid #d8dada;
    }
  }
`;

export const MobileCaseListTable = styled.div`
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  width: 100%;
  height: auto;
  border-bottom: 1px solid #d8dada;
`;

export const MobileCaseListTableRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  width: 100%;
`;

export const MobileCaseListTableDataWrapper = styled.div`
  display: flex;
  padding: 8px 0px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  width: ${(props) => (props.width ? props.width : "50%")};
`;

export const MobileCaseListTableData = styled.div`
  &.tableHeader {
    font-weight: 700;
  }
  color: #000;
  font-family: neue-haas-grotesk-text;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  word-break: break-word;
  display: -webkit-box;
  // max-width: 400px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CustomTableHeader = styled(TableHeader)`
  font-family: "neue-haas-grotesk-text";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  height: 3.5rem;
  padding: 1rem 0 0.75rem 1.5rem !important;
  border-bottom: solid 1px #000;
  @media (max-width: 1000px) {
    padding: 1rem 0 0.75rem 0.5rem;
  }
`;

const CPTooltip = styled(Tooltip)`
  & span {
    & span {
      word-break: break-word;
      font-family: "neue-haas-grotesk-text" !important;
      font-style: normal;
      font-weight: 400;
      font-size: 12px !important;
      line-height: 18px !important;
    }
  }
`;

export const CustomisedCell = styled(Cell)`
  font-family: "neue-haas-grotesk-text";
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "12px")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "16px")};
  word-break: break-word;
  width: ${(props) => props.width};
  padding-right: 0rem !important;
  padding-left: 1.5rem !important;
  height: 32px;
  @media (max-width: 1024px) {
    height: auto;
  }
`;

const CustomCell = styled(Cell)`
  max-width: ${(props) => (props.windowSize.width <= 819 ? "7rem" : "14rem")};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 0;
  font-family: "neue-haas-grotesk-text";
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
`;

const MobileCase = ({ casedata, regionIdValue, t, trackACase, getWidth, TABLET }) => (
  <MobileCaseListTable key={casedata.caseNo}>
    <MobileCaseListTableRow>
      <MobileCaseListTableDataWrapper width={getWidth("18.75%")}>
        <MobileCaseListTableData tabIndex="0" aria-label="Case number" className="tableHeader">
          {t("Case #")}
        </MobileCaseListTableData>
      </MobileCaseListTableDataWrapper>
      <MobileCaseListTableDataWrapper width={getWidth("81.25%")}>
        <CaseNumberTextLink id="view-case-link" size="small" type="standAlone" onClick={() => trackACase(casedata.caseId)}>
          {casedata.caseNo}
        </CaseNumberTextLink>
      </MobileCaseListTableDataWrapper>
    </MobileCaseListTableRow>
    <MobileCaseListTableRow>
      <MobileCaseListTableDataWrapper width={getWidth("18.75%")}>
        <MobileCaseListTableData tabIndex="0" aria-label="Subject">
          {t("Subject")}
        </MobileCaseListTableData>
      </MobileCaseListTableDataWrapper>
      <MobileCaseListTableDataWrapper width={getWidth("81.25%")}>
        <MobileCaseListTableData>{casedata.subject}</MobileCaseListTableData>
      </MobileCaseListTableDataWrapper>
    </MobileCaseListTableRow>
    <MobileCaseListTableRow>
      <MobileCaseListTableDataWrapper width={getWidth("18.75%")}>
        <MobileCaseListTableData tabIndex="0" aria-label="Details" className="tableHeader">
          {t("Details")}
        </MobileCaseListTableData>
      </MobileCaseListTableDataWrapper>
      <MobileCaseListTableDataWrapper width={getWidth("81.25%")}>
        <MobileCaseListTableData>{t(`${casedata.issueDescription}`)}</MobileCaseListTableData>
      </MobileCaseListTableDataWrapper>
    </MobileCaseListTableRow>
    <MobileCaseListTableRow>
      <MobileCaseListTableDataWrapper width={getWidth("18.75%")}>
        <MobileCaseListTableData tabIndex="0" aria-label="Created">
          {t("Created")}
        </MobileCaseListTableData>
      </MobileCaseListTableDataWrapper>
      <MobileCaseListTableDataWrapper width={getWidth("81.25%")}>
        {" "}
        <MobileCaseListTableData>{casedata.created_date}</MobileCaseListTableData>
      </MobileCaseListTableDataWrapper>
    </MobileCaseListTableRow>
    <MobileCaseListTableRow>
      <MobileCaseListTableDataWrapper width={getWidth("18.75%")}>
        <MobileCaseListTableData tabIndex="0" aria-label="Updated">
          {t("Updated")}
        </MobileCaseListTableData>
      </MobileCaseListTableDataWrapper>
      <MobileCaseListTableDataWrapper width={getWidth("81.25%")}>
        {" "}
        <MobileCaseListTableData>{casedata.lastModifiedDate || ""}</MobileCaseListTableData>
      </MobileCaseListTableDataWrapper>
    </MobileCaseListTableRow>
    <MobileCaseListTableRow>
      <MobileCaseListTableDataWrapper width={getWidth("18.75%")}>
        <MobileCaseListTableData>
          <MobileCaseListTableData className="tableHeader">{t("Status")}</MobileCaseListTableData>
        </MobileCaseListTableData>
      </MobileCaseListTableDataWrapper>
      <MobileCaseListTableDataWrapper width={getWidth("81.25%")}>
        <Chip status={casedata.status}>{t(`${casedata.status}`)}</Chip>
      </MobileCaseListTableDataWrapper>
    </MobileCaseListTableRow>
  </MobileCaseListTable>
);

MobileCase.propTypes = {
  casedata: PropTypes.object.isRequired,
  regionIdValue: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  trackACase: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired,
  TABLET: PropTypes.number.isRequired,
};

function ViewCases(props) {
  const navigate = useNavigate();
  const [filesToBeUploaded, setFilesToBeUploaded] = useState([]);
  const [t, i18n] = useTranslation("casesTranslation");
  const emeaRegionId = ["250", "276", "372", "528", "826", "40", "56", "380", "620", "724", "616"];
  const [createSortData, setCreateSortData] = useState("");
  const [updatedSortData, setUpdatedSortData] = useState("");
  const [showEmptylistNotification, setShowEmptylistNotification] = useState(false);
  const [ariaLabelText, setAriaLabelText] = useState("");

  const supportCasesRef = useRef(null);

  useEffect(() => {
    if (!props.loading) supportCasesRef?.current?.focus();
  }, [props.loading]);

  useEffect(() => {
    window.scrollTo(0, 0);
    props.setCaseCreatedSuccess(false);
    return () => props.setCaseCreatedSuccess(false);
  }, []);

  useEffect(() => {
    chatDisplayHandler(sessionStorage.getItem("currentPath"));
  }, []);

  useEffect(() => {
    props?.getAllCases();
    return () => props?.reset();
  }, []);

  useEffect(() => {
    document.title = props.title;
  }, [props.title]);

  useEffect(() => {
    i18n.changeLanguage(changeLanguageHandler(props.userLanguage));
  }, [props.userLanguage]);

  useEffect(() => {
    const isEmpty = props.caseList && props.caseList.length === 0 && !props.isError;
    setShowEmptylistNotification(isEmpty);
  }, [props.caseList, props.isError]);

  useEffect(() => {
    const failedFiles = props.fileStatusResponse.reduce((acc, status, i) => {
      if (status === "false") acc.push(props.fileName[i]);
      return acc;
    }, []);
    if (failedFiles.length > 0) {
      setFilesToBeUploaded(failedFiles);
      props.setFileTryAgainModal(true);
    }
  }, [props.fileStatusResponse]);

  const handleLoadTableData = (activePageNo = props.activePage, data = props.filteredCaseList) => {
    const lastRecordIndex = activePageNo * props.recordsPerPage;
    const firstRecordIndex = lastRecordIndex - props.recordsPerPage;
    const slicedData = data.slice(firstRecordIndex, lastRecordIndex);
    props.setTotalNumberOfRecords(data.length);
    props.setCasesPerPage(slicedData);
  };

  const handlePageChange = (pageNumber) => {
    const page = parseInt(pageNumber, 10);
    props.setActivePage(page);
    handleLoadTableData(page);
  };

  const setTextSearch = (event) => {
    const input = event.target.value.toLowerCase();
    props.setSearchInput(input);
    if (input.length > 2) {
      props.setSearchBasedOn("caseNo_And_caseDetails_subject");
      handleStatusFilter(input, "caseNo_And_caseDetails_subject", props.appliedDateFrom, props.appliedStatus);
    } else if (input.trim().length === 0) {
      handleStatusFilter("", "", props.appliedDateFrom, props.appliedStatus);
    }
  };

  const setStatusDropdown = (value) => {
    if (props.closedCaseList.length && value !== "closed") {
      props.clearClosedCases();
    }
    props.setStatus(value);
  };

  const handleApplyFilter = () => {
    handleStatusFilter(props.searchInput, props.searchBasedOn, props.dateFrom, props.status);
    props.setAppliedFromDate(props.dateFrom);
    props.setAppliedStatus(props.status);
  };

  const handleStatusFilter = (input, searchField, fromDate, statusVal) => {
    if (statusVal !== "All") {
      let filteredData = props.caseList.filter((data) => data.status === statusVal);
      handleDateFilter(input, searchField, fromDate, filteredData);
    } else {
      handleDateFilter(input, searchField, fromDate, props.caseList);
    }
  };

  const handleDateFilter = (input, searchField, fromDate, filteredData) => {
    if (fromDate) {
      filteredData = filteredData.filter((data) => data.created_date === fromDate);
    }
    handlesearchFilter(input, searchField, filteredData);
  };

  const handlesearchFilter = (input, searchField, filteredData) => {
    if (input.length > 0) {
      if (searchField === "caseNo_And_caseDetails_subject") {
        filteredData = filteredData.filter(
          (data) =>
            (data.caseNo ? data.caseNo.includes(input) : false) ||
            (data.issueDescription ? data.issueDescription.toLowerCase().includes(input) : false) ||
            (data.issueDescription ? t(data.issueDescription).toLowerCase().includes(input) : false) ||
            (data.subject ? data.subject.toLowerCase().includes(input) : false) ||
            (data.subject ? t(data.subject).toLowerCase().includes(input) : false)
        );
      }
    }
    handleFilter(filteredData);
  };

  const handleFilter = (filteredData) => {
    props.setFilteredCaseList(filteredData);
    props.setActivePage(1);
    handleLoadTableData(1, filteredData);
  };

  const viewCreateCase = () => {
    props.getTypeArr();
  };

  const trackACase = (caseId) => {
    navigate(`/support/cases/viewCaseDetails/${caseId}`);
  };

  const handleDateFilterFrom = (value) => {
    const dateFormat = props.dateFormat;
    const formattedDate = moment(value).format(dateFormat.toUpperCase());
    props.setFromDate(formattedDate);
  };

  const tableSort = (value, status, statusName, field) => {
    let result = status === "ascending" ? "descending" : "ascending";
    if (statusName === "createdSortStatus") {
      setCreateSortData(result);
    }
    if (statusName === "updatedSortStatus") {
      setUpdatedSortData(result);
    }

    const isDescending = status === "ascending";
    sortFields(value, isDescending);

    if (statusName !== "createdSortStatus") {
      setCreateSortData("");
    }
    if (statusName !== "updatedSortStatus") {
      setUpdatedSortData("");
    }
    setTimeout(() => {
      setAriaLabelText(`${field} date. Sorted in ${result} order`);
    }, 100);
  };

  const sortFields = (filterField, status) => {
    let filterCasesArr = props.status === "All" ? [...props.caseList] : props.caseList.filter((data) => data.status === props.status);

    filterCasesArr.sort((a, b) => {
      // Parse dates using the regional format from props.dateFormat
      const dateA = moment(a[filterField], props.dateFormat?.toUpperCase(), true);
      const dateB = moment(b[filterField], props.dateFormat?.toUpperCase(), true);

      // If moment parsing fails, fallback to new Date() for backward compatibility
      const dateValueA = dateA.isValid() ? dateA.toDate() : new Date(a[filterField]);
      const dateValueB = dateB.isValid() ? dateB.toDate() : new Date(b[filterField]);

      return status ? dateValueB - dateValueA : dateValueA - dateValueB;
    });

    handleLoadTableData(props.activePageNo, filterCasesArr);
  };

  const isTablet = props.windowSize.width < TABLET;
  const isDesktop = props.windowSize.width >= DESKTOP;
  const isLargeDesktop = props.windowSize.width < LARGE_DESKTOP;

  const buttonHeight = () => (isTablet ? "2rem" : "2.5rem");
  const buttonWidth = () => (isTablet ? "100%" : "fit-content");

  const isLDesktop = () => (props.windowSize.width < LARGE_DESKTOP ? "flex-start" : "flex-end");

  const justifyContent = () => {
    return isTablet ? "flex-start" : "flex-end";
  };

  const flexDirection = () => {
    return isTablet ? "column" : "row";
  };

  const isSmallGermanScreen = () => {
    return props.userLanguage === "de-DE" && props.windowSize.width <= 374 ? "supportContainer" : "";
  };

  const hasReadOnlyPermission =
    props.viewallotherCasesPermission === "ReadOnly" ||
    props.viewFinancialCasesPermission === "ReadOnly" ||
    props.regionId === "840" ||
    props.regionId === "124";
  const marginBottomValue = () => (hasReadOnlyPermission ? "0rem" : "2.5rem");

  const getFontSize = (userLanguage, isTablet, isDesktop) => {
    if (userLanguage === "nl-NL" && !isTablet) {
      return "0.8rem";
    } else if (isDesktop) {
      return "";
    } else {
      return "1rem";
    }
  };

  const getMaxWidth = () => {
    if (isLargeDesktop) {
      return isTablet ? "100%" : "18rem";
    } else {
      return "auto";
    }
  };

  const getCellClassName = () => {
    const classNameMapping = {
      "de-DE": "issueDescriptionStyleDE",
      "nl-NL": "issueDescriptionStyleNL",
    };
    return classNameMapping[props.userLanguage] || "";
  };

  const renderSortingIcons = (sortType) => {
    if (sortType === "ascending") {
      return <SortIconStyle1 alt="ascending-icon" src={AscendingSortIcon} aria-hidden="true" tabIndex="-1" />;
    } else if (sortType === "descending") {
      return <SortIconStyle1 alt="descending-icon" src={DescendingSortIcon} aria-hidden="true" tabIndex="-1" />;
    } else {
      return <SortIconStyle alt="search-icon" src={NoSort} aria-hidden="true" tabIndex="-1" />;
    }
  };

  if (props.loading) {
    return <Loader active={props.loading} fullscreen={true} />;
  }
  if (props.isError) {
    return <FailedToLoadData title={t("Support cases")} />;
  }

  const getTitleFontSize = (isSmallScreen) => (isSmallScreen ? "1.5rem" : "40px");

  const shouldShowsuccess = props.caseCreatedSuccess || props.fileTryAgainSuccess;

  const getSuccessMessage = () => {
    return props.caseCreatedSuccess ? t("Successfully created case") : t("Successfully attached files");
  };

  console.log("props.caseCreatedSuccess===>>", props.caseCreatedSuccess);

  const isMobileView = props.windowSize.width < DESKTOP;
  const showEmeaNote = emeaRegionId.includes(props.regionId);
  const buttonMargin = () => (isTablet ? "0.5rem" : undefined);
  const translatedMessage = t(props.message);
  const portalNote = t("This list contains only cases created using the Customer Portal.");

  const alignItemsValue = () => (isDesktop ? "baseline" : undefined);
  const flexDirectionValue = () => (isTablet ? "column-reverse" : "row");
  const buttonWidthValue = () => (isTablet ? "100%" : "auto !important");
  const marginTopValue = () => (isDesktop && hasReadOnlyPermission ? "0rem" : "2.5rem");
  const marginTopDateFilter = () => (isDesktop ? "10px" : undefined);
  const widthValue = () => (isTablet ? "100%" : undefined);

  const renderAnchorElement = (issueDescription) => <CustomCell className={getCellClassName()}>{t(issueDescription)}</CustomCell>;

  const renderIssueDescriptionCell = (issueDescription) => {
    if (issueDescription) {
      return (
        <CustomisedCell
          aria-colindex="4"
          style={{
            maxWidth: "14rem",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {t(issueDescription)}
        </CustomisedCell>
      );
    }

    return (
      <CustomisedCell width="21.22%" className="tooltip_customstyle" style={{ cursor: "pointer" }}>
        <CPTooltip renderAnchorElement={renderAnchorElement(issueDescription)}>{t(issueDescription)}</CPTooltip>
      </CustomisedCell>
    );
  };

  const getWidth = (percentage) => (props.windowSize.width >= TABLET ? percentage : undefined);

  // Helper for dynamic aria label
  const getDynamicAriaLabel = (casesPerPage) => (casesPerPage && casesPerPage.length > 0 ? casesPerPage.length : 0);

  return (
    <>
      {showEmptylistNotification ? (
        //Check if No cases are preset and show Notification
        <EmptylistNotification title={t("No support cases yet")}>
          {hasReadOnlyPermission ? (
            t("If Support creates a case on your behalf, you can view and manage it here.")
          ) : (
            <>
              <CustomisedTextLink
                id="create-a-support-case-link"
                type="standAlone"
                size="large"
                aria-label={t("Create a Support case")}
                style={{ color: "#0077B4", cursor: "pointer" }}
                onClick={viewCreateCase}
              >
                {t("Create a Support case")}
              </CustomisedTextLink>
              {", "}
              {t("which you can then manage here.")}
            </>
          )}
        </EmptylistNotification>
      ) : (
        //Render Support cases
        <div className={isSmallGermanScreen()} style={{ marginBottom: "4rem" }}>
          <Wrapper marginBottom="4rem">
            <CustomisedTitle fontSize={getTitleFontSize(props.fontSize < LARGE_DESKTOP)} lineHeight="48px">
              <Title size="large" primitive="h1" aria-level="1">
                {t("Support cases")}
              </Title>
            </CustomisedTitle>
            <TextWrapper fontSize="14px" marginTop="24px" marginBottom="0">
              {t("View and manage your support cases.")}
            </TextWrapper>
          </Wrapper>
          {shouldShowsuccess && (
            <div style={{ marginBottom: "24px" }}>
              <CPNotification type="success" isOpen={true} width="auto" height="auto">
                <Wrapper fontSize="0.875rem" fontFamily="neue-haas-grotesk-text">
                  {getSuccessMessage()}
                </Wrapper>
              </CPNotification>
            </div>
          )}
          <Wrapper display="flex" justifyContent={justifyContent()} flexDirection={flexDirection()} marginBottom={marginBottomValue()}>
            <Wrapper display="flex" alignItems={alignItemsValue()} flexDirection={flexDirectionValue()}>
              {hasReadOnlyPermission ? (
                <span></span>
              ) : (
                <CPButton
               
                  id="create-new-case"
                  size="large"
                  fontSize="14px"
                  fontPaddingLeft="1rem"
                  fontPaddingRight="1rem"
                  boxButton={true}
                  buttonWidth={buttonWidthValue()}
                  style={{
                    height: "2.5rem",
                    marginTop: "0rem",
                    width: buttonWidthValue(),
                  }}
                  onClick={viewCreateCase}
                >
                  {t("CREATE NEW CASE")}
                </CPButton>
              )}
            </Wrapper>
          </Wrapper>
          <Wrapper
            display="flex"
            marginTop={marginTopValue()}
            flexDirection={props.windowSize.width < LARGE_DESKTOP && "column"}
            alignItems={isLDesktop()}
            style={{ gap: "24px" }}
          >
            <SearchFilterRedesign
              placeHolder={t("Search by case number, subject, or details")}
              searchText={props.searchInput}
              handleTextSerach={setTextSearch}
              width="100%"
              label={t("Search")}
              dynamicAriaLabel={getDynamicAriaLabel(props.casesPerPage)}
            />

            <Wrapper
              display="inline-flex"
              justifyContent={isLDesktop()}
              alignItems="flex-end"
              width={widthValue()}
              style={{ gap: "16px" }}
              flexDirection={flexDirection()}
            >
              <DateFilter
                labelText={t("Date created")}
                date={handleDateTimeZone(props.dateFrom)}
                placeHolder={t(props.dateFormat.toLowerCase())}
                DateFlag={"From"}
                handleDateFilter={(value) => (value ? handleDateFilterFrom(value) : props.setFromDate(""))}
                inputWidth="inherit"
                marginTop={marginTopDateFilter()}
                marginRight={"0"}
              />
              <DropdownFilter
                label={t("Status")}
                optionValues={props.statusValues}
                optionsHandler={setStatusDropdown}
                disabled={!props.statusValues.length}
                windowSize={props.windowSize}
                statusValue={props.status}
              />
              <CPButton
                id="status-apply-button"
                boxButton={true}
                marginBottom="0.2rem"
                height={buttonHeight()}
                buttonWidth={buttonWidth()}
                marginLeft={"0rem"}
                secondary={true}
                onClick={handleApplyFilter}
                fontSize={getFontSize(props.userLanguage, isTablet, isDesktop)}
                size="large"
                style={{
                  maxWidth: getMaxWidth(),
                  minWidth: "auto",
                }}
              >
                {t("APPLY")}
              </CPButton>
            </Wrapper>
          </Wrapper>
          {isMobileView ? (
            <>
              <TextWrapper
                lineHeight="20px"
                fontSize="14px"
                marginTop="2.5rem"
                style={{ marginBottom: buttonMargin() }}
                aria-label={translatedMessage}
                tabIndex="0"
              >
                <>{t(translatedMessage)}</>
                {showEmeaNote && (
                  <>
                    <br />
                    <p style={{ margin: "0" }} aria-label={portalNote}>
                      {portalNote}
                    </p>
                  </>
                )}
              </TextWrapper>

              <Wrapper style={{ borderTop: "2px solid black", width: "100%" }}>
                {props.casesPerPage.length !== 0 ? (
                  props.casesPerPage.map((caseData) => (
                    <MobileCase 
                      key={caseData.caseNo} 
                      casedata={caseData} 
                      regionIdValue={props.regionId}
                      t={t}
                      trackACase={trackACase}
                      getWidth={getWidth}
                      TABLET={TABLET}
                    />
                  ))
                ) : (
                  <MobileCaseListTable>
                    <MobileCaseListTableRow>
                      <MobileCaseListTableDataWrapper>
                        <MobileCaseListTableData tabIndex="0" aria-label="No support cases to display">
                          {t("No support cases to display")}
                        </MobileCaseListTableData>
                      </MobileCaseListTableDataWrapper>
                    </MobileCaseListTableRow>
                  </MobileCaseListTable>
                )}
              </Wrapper>
              {props.casesPerPage.length !== 0 && (
                <PageAlignment
                  activePage={props.activePage}
                  recordsPerPage={props.recordsPerPage}
                  totalNumberOfRecords={props.totalNumberOfRecords}
                  pageRangeDisplayed={props.pageRangeDisplayed}
                  handlePageChange={handlePageChange}
                />
              )}
            </>
          ) : (
            <>
              <TextWrapper lineHeight="20px" fontSize="14px" marginTop="2.5rem" style={{ marginBottom: buttonMargin() }} aria-label={props.message}>
                <>{t(props.message)}</>
                {emeaRegionId.includes(props.regionId) && (
                  <>
                    <br />
                    <p style={{ margin: "0" }} aria-label={portalNote}>
                      {portalNote}
                    </p>
                  </>
                )}
              </TextWrapper>
              <CaseListTable
                fontFamily="neue-haas-grotesk-text"
                topLine="none"
                aria-label="View Cases Table"
                aria-colcount="6"
                borderTop={"2px solid #000000"}
                borderBottom={"1px solid #000000"}
              >
                <thead>
                  <tr role="row">
                    <CustomTableHeader width="12.09%">{t("Case #")}</CustomTableHeader>
                    <CustomTableHeader width="17.66%">{t("Subject")}</CustomTableHeader>
                    <CustomTableHeader width="21.22%">{t("Details")}</CustomTableHeader>
                    <CustomTableHeader width="14.53%">
                      <button
                        id="sort-date-created"
                        className="sortableCol"
                        style={{
                          paddingBottom: "5px",
                          "text-wrap": "balance",
                          wordBreak: "break-all",
                        }}
                        tabIndex="0"
                        onClick={() => tableSort("created_date", createSortData, "createdSortStatus", "Created")}
                        aria-label="Created date. Click to sort the list"
                      >
                        {t("Created")}
                        {renderSortingIcons(createSortData)}
                        <div className="sr-only" aria-atomic="true">
                          {ariaLabelText}
                        </div>
                      </button>
                    </CustomTableHeader>
                    <CustomTableHeader width="14.53%">
                      <button
                        id="sort-date-updated"
                        className="sortableCol"
                        style={{
                          paddingBottom: "5px",
                          "text-wrap": "balance",
                          wordBreak: "break-all",
                        }}
                        tabIndex="0"
                        onClick={() => tableSort("lastModifiedDate", updatedSortData, "updatedSortStatus", "Updated")}
                        aria-label="Updated date. Click to sort the list"
                      >
                        {t("Updated")}

                        {renderSortingIcons(updatedSortData)}
                        <div className="sr-only" aria-atomic="true">
                          {ariaLabelText}
                        </div>
                      </button>
                    </CustomTableHeader>

                    <CustomTableHeader width="19.97%">{t("Status")}</CustomTableHeader>
                  </tr>
                </thead>
                <TableBody bottomLine={true} hasHover={false} striped={false}>
                  {props.casesPerPage.length !== 0 ? (
                    props.casesPerPage.map((caseData) => (
                      <TableRow key={caseData.caseNo}>
                        <CustomisedCell width="12.09%" aria-colindex="1" style={{ fontWeight: "bold" }}>
                          <CaseNumberTextLink id="view-case-link" size="small" type="standAlone" onClick={() => trackACase(caseData.caseId)}>
                            {caseData.caseNo}
                          </CaseNumberTextLink>
                        </CustomisedCell>
                        <CustomisedCell width="17.66%" aria-colindex="2">
                          {t(`${caseData.subject}`)}
                        </CustomisedCell>

                        {renderIssueDescriptionCell(caseData.issueDescription)}

                        <CustomisedCell width="14.53%" aria-colindex="4">
                          {caseData.created_date}
                        </CustomisedCell>
                        <CustomisedCell width="14.53%" aria-colindex="5">
                          {caseData.lastModifiedDate || ""}
                        </CustomisedCell>

                        <CustomisedCell width="19.97%" aria-colindex="6">
                          <Chip status={caseData.status} fontSize={props.windowSize.width >= 768 && props.windowSize.width <= 750 ? "10px" : "12px"}>
                            {t(`${caseData.status}`)}
                          </Chip>
                        </CustomisedCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <td colSpan="6" aria-colspan="6" aria-colindex="1" style={{ textAlign: "center", fontWeight: "bold" }}>
                        {t("No support cases to display")}
                      </td>
                    </TableRow>
                  )}
                </TableBody>
              </CaseListTable>
              {props.casesPerPage.length !== 0 && (
                <PageAlignment
                  activePage={props.activePage}
                  recordsPerPage={props.recordsPerPage}
                  totalNumberOfRecords={props.totalNumberOfRecords}
                  pageRangeDisplayed={props.pageRangeDisplayed}
                  handlePageChange={handlePageChange}
                />
              )}
            </>
          )}
        </div>
      )}
      {props.createCaseToggle && <CreateNewCase userLanguage={props.userLanguage} />}
      {props.filesTryAgainModal && <AddAttachmentTryAgain filesToBeUploaded={filesToBeUploaded} />}
      {props.tryAgain && (
        <RedesignedModal
          opened={props.tryAgain}
          onClickClose={() => props.setTryAgain(false)}
          zIndex={"1001"}
          title={t("Try Again")}
          ModalAriaLabel="Try again modal"
          isScrollable={false}
          button={
            <>
              <CustomisedTertiaryButton
                ariaLabel="Cancel"
                id={"continue-session"}
                onClick={() => props.setTryAgain(false)}
                buttonWidth={buttonWidth()}
                buttonHeight={"40px"}
                fontSize={"14px"}
              >
                {t("Cancel")}
              </CustomisedTertiaryButton>
              <CPButton
                width="autoTight"
                id={"Leave-button"}
                buttonHeight={"40px"}
                buttonWidth={buttonWidth()}
                ariaLabel="Try again"
                boxButton={true}
                onClick={() => props.getTypeArr()}
                style={{ height: "2.5rem" }}
                fontSize={"14px"}
              >
                {t("Try again")}
              </CPButton>
            </>
          }
        >
          <Wrapper
            aria-label="Unable to create a new case at this time. Please try again. If the problem persists, contact support"
            fontFamily="neue-haas-grotesk-text"
            fontStyle="normal"
            fontWeight="400"
            fontSize="14px"
            marginBottom="0"
            marginTop="0"
            tabIndex="0"
          >
            {t("UnableToCreateCase1")}
            {/* <br /> */} {` ${t("UnableToCreateCase2")}`}{" "}
            <CustomisedTextLink
              fontSize="0.875rem"
              onClick={() => helpNavigationHandler(props.regionId, "Customer Portal | Support Cases | Help", props.accountNumber, true)}
            >
              {t("contact support")}
            </CustomisedTextLink>
          </Wrapper>
        </RedesignedModal>
      )}
    </>
  );
}

const mapDispatchToProps = {
  getAllCases: Actions.getAllCases,
  getClosedCases: Actions.getClosedCases,
  clearClosedCases: Actions.clearClosedCases,
  reset: Actions.reset,
  setTotalNumberOfRecords: Actions.setTotalNumberOfRecords,
  setCasesPerPage: Actions.setCasesPerPage,
  setActivePage: Actions.setActivePage,
  setSearchInput: Actions.setSearchInput,
  setSearchBasedOn: Actions.setSearchBasedOn,
  setFromDate: Actions.setFromDate,
  setToDate: Actions.setToDate,
  setStatus: Actions.setStatus,
  setAppliedFromDate: Actions.setAppliedFromDate,
  setAppliedToDate: Actions.setAppliedToDate,
  setAppliedStatus: Actions.setAppliedStatus,
  setFilteredCaseList: Actions.setFilteredCaseList,
  toggleCreateCase: Actions.toggleCreateCase,
  setCreateCaseReset: CreateCaseActions.reset,
  setTryAgain: CreateCaseActions.setTryAgain,
  getTypeArr: CreateCaseActions.getTypeArr,
  setCaseID: ViewCasesDetailsActions.setCaseID,
  setFileTryAgainModal: GlobalActions.setFileTryAgainModal,
  getBannerMessage: GlobalActions.getBannerMessage,
  setIsError: Actions.setIsError,
  setCaseCreatedSuccess: Actions.setCaseCreatedSuccess,
};
const mapStateToProps = (state) => {
  return {
    viewallotherCasesPermission: state.ACCOUNT.viewallotherCasesPermission,
    viewFinancialCasesPermission: state.ACCOUNT.viewFinancialCasesPermission,
    userLanguage: state.ACCOUNT.userLanguage,
    regionId: state.ACCOUNT.regionId,
    accountNumber: state.ACCOUNT.accountNumber,
    loading: state.CASELIST.loading,
    caseList: state.CASELIST.caseList,
    closedCaseList: state.CASELIST.closedCaseList,
    message: state.CASELIST.message,
    filteredCaseList: state.CASELIST.filteredCaseList,
    casesPerPage: state.CASELIST.casesPerPage,
    statusValues: state.CASELIST.statusValues,
    totalNumberOfRecords: state.CASELIST.totalNumberOfRecords,
    activePage: state.CASELIST.activePage,
    recordsPerPage: state.CASELIST.recordsPerPage,
    pageRangeDisplayed: state.CASELIST.pageRangeDisplayed,
    searchInput: state.CASELIST.searchInput,
    searchBasedOn: state.CASELIST.searchBasedOn,
    dateFrom: state.CASELIST.dateFrom,
    dateTo: state.CASELIST.dateTo,
    status: state.CASELIST.status,
    appliedDateFrom: state.CASELIST.appliedDateFrom,
    appliedDateTo: state.CASELIST.appliedDateTo,
    appliedStatus: state.CASELIST.appliedStatus,
    createCaseToggle: state.CASELIST.createCaseToggle,
    caseCreatedSuccess: state.CASELIST.caseCreatedSuccess,
    typeArr: state.CREATECASE.typeArr,
    tryAgain: state.CREATECASE.tryAgain,
    isLoading: state.CREATECASE.isLoading,
    fileStatusResponse: state.CREATECASE.fileStatusResponse,
    fileName: state.CREATECASE.fileName,
    caseId: state.CREATECASE.caseID,
    caseIdGlobal: state.ACCOUNT.caseIdGlobal,
    filesTryAgainModal: state.ACCOUNT.filesTryAgainModal,
    fileTryAgainSuccess: state.ACCOUNT.fileTryAgainSuccess,
    bannerDisplayOnLanding: state.ACCOUNT.bannerDisplayOnAll,
    isError: state.CASELIST.isError,
    dateFormat: state.CASELIST.dateFormat,
    windowSize: state.ACCOUNT.windowSize,
  };
};

ViewCases.propTypes = {
  setSearchInput: PropTypes.func.isRequired,
  setSearchBasedOn: PropTypes.func.isRequired,
  appliedStatus: PropTypes.string.isRequired,
  appliedDateFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  dateFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  closedCaseList: PropTypes.array.isRequired,
  setStatus: PropTypes.func.isRequired,
  clearClosedCases: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired,
  searchBasedOn: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  setAppliedFromDate: PropTypes.func.isRequired,
  setAppliedStatus: PropTypes.func.isRequired,
  getAllCases: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  setFromDate: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  userLanguage: PropTypes.string.isRequired,
  caseList: PropTypes.array.isRequired,
  dateFormat: PropTypes.string,
  isError: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  createCaseToggle: PropTypes.bool.isRequired,
  filesTryAgainModal: PropTypes.bool.isRequired,
  tryAgain: PropTypes.bool.isRequired,
  setTryAgain: PropTypes.bool.isRequired,
  setCaseCreatedSuccess: PropTypes.func.isRequired,
  fileStatusResponse: PropTypes.array.isRequired,
  fileName: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  setFileTryAgainModal: PropTypes.func.isRequired,
  activePage: PropTypes.number.isRequired,
  accountNumber: PropTypes.number.isRequired,
  filteredCaseList: PropTypes.array.isRequired,
  recordsPerPage: PropTypes.number.isRequired,
  fontSize: PropTypes.number.isRequired,
  setTotalNumberOfRecords: PropTypes.func.isRequired,
  setCasesPerPage: PropTypes.func.isRequired,
  setActivePage: PropTypes.func.isRequired,
  setFilteredCaseList: PropTypes.func.isRequired,
  getTypeArr: PropTypes.func.isRequired,
  activePageNo: PropTypes.number.isRequired,
  viewallotherCasesPermission: PropTypes.string.isRequired,
  viewFinancialCasesPermission: PropTypes.string.isRequired,
  caseCreatedSuccess: PropTypes.bool.isRequired,
  fileTryAgainSuccess: PropTypes.bool.isRequired,
  statusValues: PropTypes.array.isRequired,
  message: PropTypes.string.isRequired,
  casesPerPage: PropTypes.array.isRequired,
  totalNumberOfRecords: PropTypes.number.isRequired,
  pageRangeDisplayed: PropTypes.number.isRequired,
  regionId: PropTypes.string.isRequired,
  windowSize: PropTypes.shape({
    width: PropTypes.number,
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewCases);
